import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { projectDocumentTokenLoad } from 'portal/store/projectDocumentsToken/actions'

export const useProjectDocumentsTokenLoader = (projectId: string) => {
  const dispatch = useDispatch()
  const { accountId } = useParams<{ accountId: string }>()

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(projectDocumentTokenLoad(accountId, projectId))
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.projectDocumentsToken
  })

  return {
    loading,
    error,
    items,
    reload
  }
}
